export const SET_USER_ACTION = 'SET_USER_ACTION'
